import React, { useEffect, useState } from 'react';
import { Box, Button, Input, Text, HStack, InputGroup, InputRightElement } from '@chakra-ui/react';
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';

const PasswordForm = ({ executeAction, cancel, action }) => {
  const [password, setPassword] = useState('');
  const [inputType, setInputType] = useState('text');
  const [showPass, setShowPass] = useState(false);

  // useEffect(() => {
  //   if (password?.length > 0) {
  //     setInputType('password');
  //   } else {
  //     setInputType('text');
  //   }
  // }, [password]);

  useEffect(() => {
    if (!showPass) {
      setInputType('password');
    } else {
      setInputType('text');
    }
  }, [showPass]);

  return (
    <Box>
      <Box mt={6} border="1px solid #E53E3E" borderRadius="md" borderStyle="dashed" p={4}>
        <Text fontSize="sm" color="invalid" mb={1.5}>
          * Enter your password to confirm you want to {action?.toLowerCase() || 'reject'} this
          certificate
        </Text>
        <InputGroup>
          <InputRightElement>
            {showPass ? (
              <ViewIcon onClick={() => setShowPass(false)} cursor="pointer" mt={1.5} />
            ) : (
              <ViewOffIcon onClick={() => setShowPass(true)} cursor="pointer" mt={1.5} />
            )}
          </InputRightElement>
          <Input
            h="50px"
            isRequired
            bg="secondary"
            type={inputType}
            variant="outline"
            borderRadius="2px"
            autoComplete="off"
            focusBorderColor="primary.300"
            onChange={(e) => setPassword(e.target.value)}
          />
        </InputGroup>
        <HStack mt={4} justifyContent="right">
          <Button variant="modalAction" onClick={cancel}>
            CANCEL
          </Button>
          <Button
            bg="red.500"
            variant="modalAction"
            _hover={{ bg: 'red.400' }}
            isDisabled={password?.length < 6}
            onClick={() => {
              executeAction(password);
            }}>
            CONFIRM
          </Button>
        </HStack>
      </Box>
    </Box>
  );
};

export default PasswordForm;
